import { useLayoutEffect, useState } from 'react';
import SearchQuery from '../general/SearchQuery';
import TextPoints from '../text/TextPoints';

export default function GameAnswer({ hasRoundFinished, isFound, query, answer, points }) {
  const shouldRevealAnswer = isFound || hasRoundFinished;
  const [answerWidth, setAnswerWidth] = useState(128);

  // useLayoutEffect to prevent flickering (seeing 128px box before measuring)
  useLayoutEffect(() => {
    // Measure text without inserting it into the DOM
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    // Match the font style used in the actual element
    context.font = getComputedStyle(document.body).font;
    const metrics = context.measureText(answer);
    setAnswerWidth(metrics.width + 16); // Add some padding
  }, [answer]);

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center">
        <div className="hidden sm:inline">
          <SearchQuery text={query} />
        </div>
        {shouldRevealAnswer ? (
          <span className="ml-2 sm:ml-0 mb-2 sm:mb-0 truncate max-w-xs">{answer}</span>
        ) : (
          <div
            className="ml-2 sm:ml-0 mb-2 sm:mb-0 mt-1 h-6 bg-blue rounded"
            style={{ width: answerWidth }}
            aria-label="Hidden answer"
          />
        )}
      </div>
      <TextPoints isFound={isFound} text={points} />
    </div>
  );
}
